import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

import { CircleIcon } from '../../atoms/circle-icon/circle-icon';
import { width, height } from '../../style-utils';

export interface IconButtonProps extends TouchableOpacityProps {
  icon: string;
  iconSize: number;
  size: number;
  color: string;
  backgroundColor?: string;
  borderColor?: string;
  nativeID?: string;
  onPress: () => void;
}

export const IconButton = ({
  onPress,
  icon,
  iconSize = 20,
  size = 40,
  color,
  backgroundColor,
  borderColor,
  ...props
}: IconButtonProps) => {
  return (
    <TouchableOpacity
      style={[width(size), height(size)]}
      onPress={onPress}
      {...props}
    >
      <Icon
        backgroundColor={backgroundColor}
        borderColor={borderColor}
        name={icon}
        color={color}
        size={size}
        iconSize={iconSize}
        pointerEvents="none"
      />
    </TouchableOpacity>
  );
};

export default IconButton;

const Icon = styled(CircleIcon)`
  margin: 0;
`;
